// extracted by mini-css-extract-plugin
export default {"wrapper":"c7-z"};